import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useI18n } from "@/i18n/I18nContext";

export const ConfirmButton = ({ title, description, onConfirm, children, className, testId, confirmLabel }) => {
  const { t } = useI18n();
  return (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button type="button" className={className} data-testid={testId}>{children}</button>
    </AlertDialogTrigger>
    <AlertDialogContent className="card-carbon w-[calc(100vw-2rem)] max-w-md rounded-2xl" data-testid={`${testId}-dialog`}>
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display uppercase tracking-wider gold-text">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="gap-2">
        <AlertDialogCancel data-testid={`${testId}-cancel`}>{t("confirm.cancel")}</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-red-700 text-white hover:bg-red-600" data-testid={`${testId}-confirm`}>
          {confirmLabel || t("versions.delete")}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
  );
};
